import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import PasswordResetContainer from "../containers/PasswordResetContainer";

const PasswordResetPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <PasswordResetContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default PasswordResetPage;
